import React, { useState } from 'react';
import { useAuth } from '../hooks/useAuth';
import { Menu, ChefHat } from 'lucide-react';
import Sidebar from './Sidebar';

interface LayoutProps {
  children: React.ReactNode;
}

const Layout: React.FC<LayoutProps> = ({ children }) => {
  const [isMobileSidebarOpen, setIsMobileSidebarOpen] = useState(false);
  const { user } = useAuth();

  const toggleMobileSidebar = () => {
    setIsMobileSidebarOpen(!isMobileSidebarOpen);
  };

  // Si no hay usuario (no está autenticado), no mostrar el layout
  if (!user) {
    return <>{children}</>;
  }

  return (
    <div className="flex h-screen bg-gray-50 dark:bg-gray-900">
      {/* Sidebar para desktop */}
      <div className="hidden lg:block">
        <Sidebar />
      </div>

      {/* Sidebar para móvil */}
      <Sidebar
        isMobile={true}
        isOpen={isMobileSidebarOpen}
        onToggle={toggleMobileSidebar}
      />

      {/* Contenido principal */}
      <div className="flex-1 flex flex-col overflow-hidden">
        {/* Header móvil */}
        <div className="lg:hidden bg-white dark:bg-gray-800 border-b border-gray-200 dark:border-gray-700 p-4">
          <div className="flex items-center justify-between">
            <div className="flex items-center space-x-2">
              <button
                onClick={toggleMobileSidebar}
                className="p-2 rounded-md hover:bg-gray-100 dark:hover:bg-gray-700"
              >
                <Menu className="h-5 w-5 text-gray-500 dark:text-gray-400" />
              </button>
              <div className="flex items-center space-x-2">
                <div className="bg-blue-600 p-1 rounded">
                  <ChefHat className="h-4 w-4 text-white" />
                </div>
                <span className="font-bold text-gray-900 dark:text-gray-100">
                  Suminuta
                </span>
              </div>
            </div>
          </div>
        </div>

        {/* Contenido de la página */}
        <main className="flex-1 overflow-auto">{children}</main>
      </div>
    </div>
  );
};

export default Layout;
